import { DocumentTextIcon } from "@heroicons/react/outline";

export const Attachments = ({
  attachments,
  files,
}: {
  attachments: {
    approvalLetter: {
      selectedFiles: [];
    };
    taxReturn: {
      selectedFiles: [];
    };
    payStubs: {
      selectedFiles: [];
    };
    bankStatements: {
      selectedFiles: [];
    };
  };
  files: any[];
}) => {
  const getFileUrl = (fileKey: string) => {
    const item = files.find((f) => f.key === fileKey);
    return item?.url;
  };

  return (
    <>
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="py-5">
            <div className="px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal">
              <h2
                id="applicant-information-title"
                className="m-0 text-lg leading-6 font-medium text-primaryColor-normal"
              >
                Attachments
              </h2>
            </div>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-6">
            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-x-4 gap-y-8">
                <div>
                  <dt className="text-sm font-medium text-gray-500">
                    1st Mortgage Pre-Approval Letter
                  </dt>
                  {attachments?.approvalLetter?.selectedFiles
                    ? attachments?.approvalLetter?.selectedFiles.map(
                        (d: any) => (
                          <a
                            href={getFileUrl(d.key)}
                            target="_blank"
                            rel="noreferrer"
                            download
                          >
                            <dd className="mt-1 gap-1 text-sm text-gray-900 normal-case flex hover:underline cursor-pointer">
                              <DocumentTextIcon className="w-5 h-5 text-neutralColor-normal" />
                              {d.name}
                            </dd>
                          </a>
                        )
                      )
                    : "None"}
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Most Recent Tax Return
                  </dt>
                  {attachments?.taxReturn?.selectedFiles
                    ? attachments?.taxReturn?.selectedFiles.map((d: any) => (
                        <a
                          href={getFileUrl(d.key)}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <dd className="mt-1 gap-1 text-sm text-gray-900 normal-case flex hover:underline cursor-pointer">
                            <DocumentTextIcon className="w-5 h-5 text-neutralColor-normal" />
                            {d.name}
                          </dd>
                        </a>
                      ))
                    : "None"}
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Two Months of Most Recent Pay Stubs
                  </dt>
                  {attachments?.payStubs?.selectedFiles
                    ? attachments?.payStubs?.selectedFiles.map((d: any) => (
                        <a
                          href={getFileUrl(d.key)}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <dd className="mt-1 gap-1 text-sm text-gray-900 normal-case flex hover:underline cursor-pointer">
                            <DocumentTextIcon className="w-5 h-5 text-neutralColor-normal" />
                            {d.name}
                          </dd>
                        </a>
                      ))
                    : "None"}
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    3 Months of Bank Statements
                  </dt>
                  {attachments?.bankStatements?.selectedFiles
                    ? attachments?.bankStatements?.selectedFiles.map(
                        (d: any) => (
                          <a
                            href={getFileUrl(d.key)}
                            target="_blank"
                            rel="noreferrer"
                            download
                          >
                            <dd className="mt-1 gap-1 text-sm text-gray-900 normal-case flex hover:underline cursor-pointer">
                              <DocumentTextIcon className="w-5 h-5 text-neutralColor-normal" />
                              {d.name}
                            </dd>
                          </a>
                        )
                      )
                    : "None"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
